import { BabyGoal, getAnnualReturnUsingRiskScore } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const BABY: BaseGoalConfig<BabyGoal> = {
    iconName: 'GoalBaby',
    color: colorsByGoalType['BABY'].primary,
    defaultName: 'Have a baby',
    getDescription: () => 'Your dream team is growing.',
    group: 'INVEST',
    blogLink: {
        description: 'See Plenty’s guide on having a baby',
        url: 'https://www.withplenty.com/blog/building-your-family-financial-planning-for-future-parents',
    },
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
